import Header from "../header";
import Footer from "../footer";
import { useNavigate,useLocation} from "react-router-dom";
import { useState, useEffect } from "react";
import { submitClaim } from "apiCalls/applyClaimService";

function formatDate(iso) {
    if (!iso) return "-";
    const d = new Date(iso);
    if (isNaN(d)) return iso;
    return `${String(d.getDate()).padStart(2,"0")}/${String(d.getMonth()+1).padStart(2,"0")}/${d.getFullYear()}`;
}

function PreviewDeathClaim(){
    const navigate = useNavigate();
    const { state } = useLocation();
    const loan = state?.loan || {};
    const claim = state?.claim || {};
    const files = state?.files || {};
    const draftId = state?.draftId || null;
    const [showSuccess, setShowSuccess] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [applicationNumber, setApplicationNumber] = useState("");
    const [dodUrl, setDodUrl] = useState(null);

    useEffect(() => {
        const url = files.dodCertificateFile ? URL.createObjectURL(files.dodCertificateFile) : null;
        if (url) setDodUrl(url);
        return () => { if (url) URL.revokeObjectURL(url); };
    }, []);

    const handleSubmit = async () => {
        setSubmitting(true);
        setErrorMsg("");
        const fd = new FormData();
        if (draftId) fd.append("risk_fund_claim_id", draftId);
        fd.append("risk_fund_claim_type_id", "Mg==");
        fd.append("loan_number", loan.loanNo);
        fd.append("claimant_name", claim.claimantName);
        fd.append("relationship_to_loanee_id", claim.relationship);
        if (claim.relationshipName === "Other" && claim.otherRelationship) fd.append("other_relationship", claim.otherRelationship);
        fd.append("date_of_death", claim.dateOfDeath);
        fd.append("death_certificate_number", claim.deathCertNumber);
        fd.append("is_previous_relief_taken", claim.previousDiseaseRelief === "yes" ? 1 : 0);
        if (claim.previousDiseaseRelief === "yes") {
            fd.append("previous_relief_amount", claim.releaseAmount);
        }
        fd.append("dod_proof_file", files.dodCertificateFile);
        try {
            const res = await submitClaim(fd);
            setApplicationNumber(res.data?.application?.application_number || "");
            // Store encrypted claim ID for dashboard listing
            const claimId = res.data?.risk_fund_claim?.id || "";
            if (claimId) {
                let ids = []; try { ids = JSON.parse(localStorage.getItem("rwfms_claim_ids") || "[]"); } catch { ids = []; }
                if (!ids.includes(claimId)) {
                    localStorage.setItem("rwfms_claim_ids", JSON.stringify([...ids, claimId]));
                }
            }
            setShowSuccess(true);
        } catch (err) {
            setErrorMsg(err.message || "Something went wrong. Please try again.");
        } finally {
            setSubmitting(false);
        }
    };

    return(
        <>
        <Header/>
         {/*-- ==== Scroll up and prograss start ==== */}
            <div id="scrollUp">
                <svg className="arrowup" viewBox="0 0 24 24" width="18" height="18">
                    <path d="M13 7.828V20h-2V7.828l-5.364 5.364-1.414-1.414L12 4l7.778 7.778-1.414 1.414L13 7.828z" fill="#fff"></path>
                </svg>
                <svg className="scrollprogress" width="40" height="40">
                    <circle className="progress-circle" cx="20" cy="20" r="18" strokeWidth="2" fill="none" stroke="#fff" strokeDasharray="113.1" strokeDashoffset="113.1"></circle>
                </svg>
            </div>
            {/*-- ==== Scroll up and prograss Ends ==== */}
            {/* ==== Account Creation Page Banner Section Start ==== */}
            <section className="rs-page-banner rs-faq-page-banner pt-30 pb-30 mt-140">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7">
                            <div className="rs-page-banner__content">
                                <h1 className="title">Preview of Death Claim</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/*- ==== Account Creation Page Banner Section Ends ==== */}
                    {/*-- ====Page Section Start ==== */}
    <section className="rs-faq-page pt-50 pb-120">
        <div className="container">

            <div className="row justify-content-center">
                <div className="col-lg-12">

                    {/*--loan details--*/}
                    <h5 className="mb-2">Loan Details</h5>
                    <div className="list-type mb-5">
                        <div className="row">
                            <div className="col-md-3 mb-2">
                                <p>Loanee Full Name</p>
                                <h4>{loan.name}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>Aadhaar Number</p>
                                <h4>{loan.aadhaar}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>Mobile Number</p>
                                <h4>{loan.mobile}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>Loan Number</p>
                                <h4>{loan.loanNo}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>Loan Amount</p>
                                <h4>{loan.amount}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>Society Membership Number</p>
                                <h4>{loan.membership}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>Society Name</p>
                                <h4>{loan.society}</h4>
                            </div>
                             <div className="col-md-3 mb-2">
                                <p>Society Address</p>
                                <h4>{loan.societyAddress}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>Date of Birth</p>
                                <h4>{loan.dob}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>Birth Certificate Number</p>
                                <h4>{loan.birthCertificateNumber}</h4>
                            </div>
                        </div>
                    </div>
                    {/*--loan details--*/}
                    {/*-- Death Claim Details */}
                     <h5 className="mb-2">Death Claim Details</h5>
                     <div className="list-type mb-5">
                        <div className="row">
                            <div className="col-md-3 mb-2">
                                <p>Claimant Name</p>
                                <h4>{claim.claimantName}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>Relationship to Loanee</p>
                                <h4>{claim.relationshipName || claim.relationship}</h4>
                            </div>
                            {claim.relationshipName==="Other" &&(
                                <div className="col-md-3 mb-2">
                                <p>Specify Relationship</p>
                                <h4>{claim.otherRelationship}</h4>
                            </div>
                            )}
                            <div className="col-md-3 mb-2">
                                <p>Date of Death</p>
                                <h4>{formatDate(claim.dateOfDeath)}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>Death Certificate Number</p>
                                <h4>{claim.deathCertNumber}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p>Previous Disease Relief taken</p>
                                <h4>{claim.previousDiseaseRelief}</h4>
                            </div>
                            {claim.previousDiseaseRelief === "yes" && (
                            <div className="col-md-3 mb-2">
                                <p>Release Amount Received</p>
                                <h4>{claim.releaseAmount}</h4>
                            </div>
                            )}
                        </div>
                    </div>
                    {/*-- Death Claim Details */}

                    {/* Uploaded Documents */}
                    <h5 className="mb-2">Uploaded Documents</h5>
                    <div className="list-type mb-5">
                        <div className="row">
                            {dodUrl && (
                                <div className="col-md-4 mb-2">
                                    <p>DOD Proof</p>
                                    <a href={dodUrl} target="_blank" rel="noopener noreferrer" style={{ color: "#1a5c4a", fontSize: "0.9rem" }}>
                                        <i className="fa fa-file me-1"></i> View
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>

                    {errorMsg && (
                        <div className="alert alert-danger mt-3">{errorMsg}</div>
                    )}
                     <div className="row mt-4">
                        <div className="col-md-12 text-end">
                            <button className="btn btn-secondary me-3" onClick={()=>navigate("/deathClaim", { state: { loan, claim, draftId, files } })}><i className="fa fa-angle-left me-2"></i>Back</button>
                            <button type="button" className="btn btn-primary me-3" disabled={submitting} onClick={handleSubmit}>
                                {submitting
                                    ? <><span className="spinner-border spinner-border-sm me-2"></span>Submitting...</>
                                    : <><i className="fa fa-check-circle me-2"></i>Submit</>
                                }
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </section>

        <Footer/>

        {showSuccess && (
            <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <div className="card text-center p-5" style={{ maxWidth: "420px", width: "90%" }}>
                    <div className="mb-3">
                        <i className="fa fa-check-circle" style={{ fontSize: "3.5rem", color: "#25826a" }}></i>
                    </div>
                    <h4 className="mb-2">Claim Submitted Successfully!</h4>
                    {applicationNumber && (
                        <div className="mb-2 px-3 py-2 rounded" style={{ backgroundColor: "#eaf4f0", border: "1px solid #c2ddd5" }}>
                            <span className="text-muted small">Application No</span>
                            <div className="fw-bold" style={{ color: "#1a5c4a", fontSize: "1.1rem", letterSpacing: "0.5px" }}>{applicationNumber}</div>
                        </div>
                    )}
                    <p className="text-muted mb-4">Your death claim application has been submitted. You will be notified about the status shortly.</p>
                    <button className="btn btn-primary" onClick={() => navigate("/userDashboard")}>Go to Home</button>
                </div>
            </div>
        )}
        </>
    )
}

export default PreviewDeathClaim
